<template>
  <div class="address-detail-stats">
    <div class="info-board">
      <div class="stats-info-card blue-business-bg" style="width: 160px;">
        <div class="info-card-left">
          <span class="title">{{ palletCount }} Pallets</span>
          <span class="sub-title">To {{ addressCode }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { queryPallets } from '@/api/pallet'
import { NotIncludeDeleted } from '@/core/models/pallet'
export default {
  name: 'AddressDetailStats',
  props: {
    address: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      palletCount: 0,
      goodsCount: 0
    }
  },
  watch: {},
  computed: {
    addressCode() {
      return this.address?.code ?? ''
    },
    addressId() {
      return this.address?.id ?? ''
    }
  },
  methods: {
    getPalletCount() {
      if (this.addressId) {
        queryPallets({
          addressId: this.addressId,
          size: 0,
          statusList: NotIncludeDeleted
        }).then(res => {
          this.palletCount = res.total
        })
      }
    }
  },
  mounted() {
    this.getPalletCount()
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.info-board {
  gap: 20px;
  flex-wrap: wrap;

  .stats-info-card {
    pointer-events: none;
    width: 200px;

    .info-card-left {
      .title {
        font-size: 30px;
        font-family: 'oswald bold', sans-serif;
      }

      .sub-title {
        margin-top: 5px;
        font-size: 24px;
        font-family: 'oswald light', sans-serif;
      }
    }
  }

  @extend .global-margin;
  @extend .f-r-vc;
}
</style>
